const camelToDash = string => {
  return string
    .replace(/[A-Z][A-Z]+/g, w => {
      // Handle cases with acronyms (e.g. waymarkedMTB)
      const first = w.substring(0, 1);
      const rest = w.substring(1).toLowerCase();
      return `${first}${rest}`;
    })
    .replace(/[\w]([A-Z])/g, m => {
      // Normal conversion
      return `${m[0]}-${m[1]}`;
    })
    .toLowerCase();
};

export { camelToDash };
